import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { saveServiceInfo, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import ServiceInfoForm from '../components/ServiceInfoForm.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveServiceInfoForm(values, dispatch) {
            dispatch(submitForm())
            return dispatch(saveServiceInfo(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint)
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceInfoForm);


/** WEBPACK FOOTER **
 ** ./src/containers/ServiceInfoFormContainer.js
 **/